export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";